@let items = (users$ | async) ?? [];

<lib-multiselect
  titleTranslationKey="monitoring.user"
  chosenTranslationKey="monitoring.users-chosen"
  [options]="items"
  [formControl]="controlEntity"
  (shouldLoadMoreOptions)="loadMore()"
/>
